import styled from 'styled-components';

export const Modal = styled.div`
  position: fixed;
  min-width: 300px;
  width: 80vw;
  height: 50vh;
  min-height: 300px;
  background-color: ${(props) => props.theme.backgroundColor};

  left: 50%;
  top: 10vh;
  transform: translate(-50%, 0);

  padding: 1.5vw;
`;

export const ModalDark = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: #0000003d;
`;
